module.exports = __webpack_public_path__ + "man-carrying-package.c246cb11fe0ed84cff3be7f9e83b3182.svg";